import React from 'react';
export function DeleteIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M8.982 19L7.65 9h2.018L11 19H8.982zm4 0l1.334-10h2.017L15 19h-2.018z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1h10v4h6v2h-1.991l-2.134 16H5.125L2.99 7H1V5h6V1zm8 2v2H9V3h6zm3.991 4H5.01l1.867 14h10.248l1.867-14z"
  }));
}